import { render, staticRenderFns } from "./stroeGoodsRecord.vue?vue&type=template&id=310853af&scoped=true&"
import script from "./stroeGoodsRecord.vue?vue&type=script&lang=js&"
export * from "./stroeGoodsRecord.vue?vue&type=script&lang=js&"
import style0 from "./stroeGoodsRecord.vue?vue&type=style&index=0&id=310853af&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310853af",
  null
  
)

export default component.exports